cv.PublicPostsRowView = Marionette.LayoutView.extend({
  tagName: 'div',
  className: 'post',
  template: cv.Templates['public/posts/posts_row'],

  events : {
  },

  templateHelpers: function(){
    return {
      title : this.model.get('share_title'),
      has_photo : this.model.get('share_image') == '' ? false : true,
      photo_path : cv.photo({
        photo_path : this.model.get('share_image'),
        transforms : {
          fit : 'crop'
        },
        url_only : true
      }),
      url : this.model.get('url'),
      description : this.model.get('share_description'),
      author_stub : this.model.get('project.stub'),
      author_name : this.model.get('author.first_name') + ' ' + this.model.get('author.last_name'),
      author_photo_path : cv.photo({
        photo_path : this.model.get('author.photo_path'),
        transforms : {
          fit : 'crop'
        },
        url_only : true
      }),
      published_at : moment(this.model.get('published_at') + 'Z').tz(cv.campaign.get('timezone')).format('MMM D')
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('PublicPostsRowView initialized');
  },

  onAttach: function(){
    imgix.fluid(this.$el.get(0), {
      rootNode: this.$el.get(0),
      updateOnResizeDown: false,
      autoInsertCSSBestPractices: true
    });
  }
});
